import React, { useEffect, useState } from "react";
import { AppButton, SectionCard } from "../../../components/ui";

const toDateInput = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
};

export default function EventOverviewPanel({
  selectedEvent,
  eventDisplayLabel,
  eventTypeLabel,
  nationLabels = [],
  formatEventDate,
  canEdit = false,
  onSaveMeta,
  isSavingMeta = false,
}) {
  const [eventDate, setEventDate] = useState("");
  const [eventTime24, setEventTime24] = useState("");

  useEffect(() => {
    if (!selectedEvent) return;
    setEventDate(toDateInput(selectedEvent.startsAt));
    setEventTime24(String(selectedEvent.startTime24 || ""));
  }, [selectedEvent]);

  if (!selectedEvent) return null;
  const isFixedFullDayEvent = ["strongestFrenzyCommander", "strongestVoidCommander"].includes(
    String(selectedEvent.eventType || ""),
  );
  const nationText = (Array.isArray(nationLabels) ? nationLabels : [])
    .filter(Boolean)
    .join(" vs ");

  return (
    <SectionCard className="events-card events-overview-panel events-panel-shell" sx={{ p: 1.75 }}>
      <div className="events-panel-header">
        <h4>Event Overview</h4>
        <span>Snapshot of the selected event at a glance.</span>
      </div>
      <div className="events-grid">
        <label>
          Event
          <input value={eventDisplayLabel || eventTypeLabel || selectedEvent.eventType || "-"} readOnly />
        </label>
        <label>
          Type
          <input value={eventTypeLabel || selectedEvent.eventType || "—"} readOnly />
        </label>
        <label>
          Date
          <input
            type="date"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            readOnly={!canEdit}
          />
        </label>
        {isFixedFullDayEvent ? (
          <label>
            Time Model
            <input value="Full day" readOnly />
          </label>
        ) : (
          <label>
            Time (24h, optional)
            <input
              type="time"
              step="60"
              value={eventTime24}
              onChange={(e) => setEventTime24(e.target.value)}
              readOnly={!canEdit}
            />
          </label>
        )}
        <label>
          Display Date
          <input value={formatEventDate(selectedEvent.startsAt)} readOnly />
        </label>
        <label>
          Nations
          <input value={nationText || "-"} readOnly />
        </label>
        <label>
          Alliances
          <input value={String((selectedEvent.alliances || []).length)} readOnly />
        </label>
        <label>
          Results Entries
          <input value={String((selectedEvent.participantResults || []).length)} readOnly />
        </label>
        <label>
          Battles Logged
          <input value={String((selectedEvent.battles || []).length)} readOnly />
        </label>
      </div>

      {canEdit && (
        <div className="events-template-admin-actions" style={{ marginTop: 12 }}>
          <AppButton
            type="button"
            onClick={() =>
              onSaveMeta?.({
                eventDate,
                startTime24: isFixedFullDayEvent ? "" : eventTime24,
              })
            }
            disabled={isSavingMeta}
          >
            {isSavingMeta ? "Saving..." : "Save Event Details"}
          </AppButton>
        </div>
      )}
    </SectionCard>
  );
}
